import React, {useState} from 'react'
import PropTypes from 'prop-types'
import style from './style.module.scss'
export const Button = (props) => {
    return (
        <button
            className={(props.white)?style.buttonWhite:style.button}
            onClick={props.onClick}
        >{props.children}</button>
    )
}

Button.defaultProps = {
    white: false
}
